<template>
  <div class="ui-frame-bg" :class="[`color-${colorType}`, { 'hook': hook } ]">
    <div class="inner-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// color: blue, blue-light, green, red, yellow, gray
export default {
  name: 'UiFrameBg',
  props: {
    colorType: {
      type: String,
      default: 'blue'
    },
    texture: {
      type: Boolean,
      default: false
    },
    hook: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-frame-bg {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: get_vh(10px);
  .inner-box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: get_vh(10px);
    // padding-top: 2%;
    overflow: hidden;
  }
  &.color-blue .inner-box {
    background-color: #0D459E;
    border: get_vh(2px) solid #193767;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #3E75CB inset;
    .label-box {
      .label-shadow {
        color: #133469;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-blue-light .inner-box {
    background-color: #4572BA;
    border: get_vh(2px) solid #134295;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #759CDB inset;
    .label-box {
      .label-shadow {
        color: #244B89;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-green .inner-box {
    background-color: #29CA6A;
    border: get_vh(2px) solid #109345;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #45E987 inset;
    .label-box {
      .label-shadow {
        color: #12A74E;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-red .inner-box {
    background-color: #CA3939;
    border: get_vh(2px) solid #820E0E;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #FA6969 inset;
    .label-box {
      .label-shadow {
        color: #820E0E;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-yellow .inner-box {
    background-color: #FEE000;
    border: get_vh(2px) solid #7B5218;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #FFF799 inset;
    .label-box {
      .label-shadow {
        color: #FFFAC1;
      }
      .label-text {
        color: #513718;
      }
    }
  }
  &.color-white .inner-box {
    background-color: #D8D8D8;
    border: get_vh(2px) solid #ACACAC;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #FFFFFF inset;
    .label-box {
      .label-shadow {
        color: #FFFFFF;
      }
      .label-text {
        color: #616161;
      }
    }
  }
  &.color-white-all .inner-box {
    background-color: #FFFFFF;
    border: get_vh(2px) solid #FFFFFF;
    box-shadow: 0px 0 0px get_vh(2px) #CCCCCC inset;
    .label-box {
      .label-shadow {
        color: transparent;
      }
      .label-text {
        color: #333333;
      }
    }
  }
  &.color-gray .inner-box {
    background-color: #717171;
    border: get_vh(2px) solid #615C5C;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #A1A1A1 inset;
    .label-box {
      .label-shadow {
        color: #535150;
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  }
  &.color-gray-light .inner-box {
    background-color: #BABABA;
    border: get_vh(2px) solid #615C5C;
    box-shadow: 0px get_vh(2px) 0px get_vh(1px) #D9D9D9 inset;
    .label-box {
      .label-shadow {
        color: #707070;
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  }
}

@media screen and (max-aspect-ratio: 3/2) {
  .ui-frame-bg.hook {
    border-radius: get_vw(10px);
    .inner-box {
      border-radius: get_vw(10px);
    }
    &.color-blue .inner-box {
      border: get_vw(2px) solid #193767;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #3E75CB inset;
    }
    &.color-blue-light .inner-box {
      border: get_vw(2px) solid #134295;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #759CDB inset;
    }
    &.color-green .inner-box {
      border: get_vw(2px) solid #109345;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #45E987 inset;
    }
    &.color-red .inner-box {
      border: get_vw(2px) solid #820E0E;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #FA6969 inset;
    }
    &.color-yellow .inner-box {
      border: get_vw(2px) solid #7B5218;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #FFF799 inset;
    }
    &.color-white .inner-box {
      border: get_vw(2px) solid #ACACAC;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #FFFFFF inset;
    }
    &.color-gray .inner-box {
      border: get_vw(2px) solid #615C5C;
      box-shadow: 0px get_vw(2px) 0px get_vw(1px) #A1A1A1 inset;
    }
  }
}
</style>